import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

/**
 * Groups Batch B (GRP-DEC-312) — membership requests awaiting THIS member's decision.
 *
 * The count is derived server-side from the member's Owner/Admin Group memberships, so an
 * ordinary member always receives zero and no client value can widen the scope. `enabled`
 * lets the caller skip the request entirely while the Groups surface is hidden.
 */
export default function useGroupsPendingRequests({ enabled = true } = {}) {
  const { data } = useQuery({
    queryKey: ["groups-pending-request-count"],
    queryFn: async () => (await api.get("/groups/pending-requests/count")).data,
    enabled,
    retry: false,
    refetchInterval: 120000,
  });
  return { total: data?.total || 0, byGroup: data?.by_group || {} };
}
